export default __webpack_public_path__ + "static/media/CindyLovelace.da6aef1e.png";